import { useAuthStore } from '../../stores/auth.store';
import { Outlet } from 'react-router-dom';

export function Protected() {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Outlet /> : null;
}
